<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="message">
                <div>
                    <el-button :plain="true" @click="open">提示</el-button>
                    <el-button :plain="true" @click="openVn">VNode</el-button>
                    <el-button :plain="true" @click="open2">成功</el-button>
                    <el-button :plain="true" @click="open3">警告</el-button>
                    <el-button :plain="true" @click="open">消息</el-button>
                    <el-button :plain="true" @click="open4">错误</el-button>
                    <hr>
                    <el-button type="text" @click="open5">点击打开 Message Box</el-button>
                    <el-button type="text" @click="open6">点击打开 Message Box</el-button>
                    <el-button type="text" @click="open7">点击打开 Message Box</el-button>
                    <el-button type="text" @click="open8">点击打开 Message Box</el-button>
                    <el-button type="text" @click="open9">点击打开 Message Box</el-button>
                    <el-button type="text" @click="open10">点击打开 Message Box</el-button>
                    <hr>
                    <p style="font-size:12px;">
                        Notification 组件提供通知功能，Element
                        注册了$notify方法，接收一个options字面量参数，在最简单的情况下，你可以设置title字段和message字段，用于设置通知的标题和正文。默认情况下，经过一段时间后
                        Notification
                        组件会自动关闭，但是通过设置duration，可以控制关闭的时间间隔，特别的是，如果设置为0，则不会自动关闭。注意：duration接收一个Number，单位为毫秒，默认为4500。
                    </p>
                    <el-button plain @click="open11">可自动关闭</el-button>
                    <el-button plain @click="open12">不会自动关闭</el-button>
                    <el-button plain @click="open13">成功</el-button>
                    <el-button plain @click="open14">警告</el-button>
                    <el-button plain @click="open15">消息</el-button>
                    <el-button plain @click="open16">错误</el-button>
                    <el-button plain @click="open17">右上角</el-button>
                    <el-button plain @click="open18">右下角</el-button>
                    <el-button plain @click="open19">左下角</el-button>
                    <el-button plain @click="open20">左上角</el-button>
                    <hr>
                    <el-button type="text" @click="dialogVisible = true">点击打开 Dialog</el-button>
                    <el-dialog
                            title="提示"
                            :visible.sync="dialogVisible"
                            width="30%"
                            :before-close="handleClose">
                        <span>这是一段信息</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>
                    |
                    <el-button type="text" @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button>
                    <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
                      <el-table :data="gridData">
                        <el-table-column property="date" label="日期" width="150"></el-table-column>
                        <el-table-column property="name" label="姓名" width="200"></el-table-column>
                        <el-table-column property="address" label="地址"></el-table-column>
                      </el-table>
                    </el-dialog>
                    |
                    <el-button type="text" @click="dialogScrollVisible = true">打开嵌el-scrollbar的 Dialog</el-button>
                    <el-dialog title="收货地址" :visible.sync="dialogScrollVisible" id="scrollbar-massage-model">
                        <el-scrollbar class="scrollbar-model b-r-4" style="height:100%">
                            <div class="massage-scroll b-r-4">
                                <div style="height:auto;overflow:hidden;">
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                    <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode1</i></p>
                                </div>
                            </div>
                        </el-scrollbar>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogScrollVisible = false">取 消</el-button>
                            <el-button type="primary" @click="dialogScrollVisible = false">确 定</el-button>
                        </div>
                    </el-dialog>
                    |
                    <!-- Form -->
                    <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button>

                    <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
                        <el-form :model="form">
                            <el-form-item label="活动名称" :label-width="formLabelWidth">
                                <el-input v-model="form.name" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="活动区域" :label-width="formLabelWidth">
                                <el-select v-model="form.region" placeholder="请选择活动区域">
                                    <el-option label="区域一" value="shanghai"></el-option>
                                    <el-option label="区域二" value="beijing"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取 消</el-button>
                            <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
                        </div>
                    </el-dialog>
                    |
                    <el-button type="text" @click="outerVisible = true">点击打开外层 Dialog</el-button>
                    <el-dialog title="外层 Dialog" :visible.sync="outerVisible">
                        <el-dialog
                                width="30%"
                                title="内层 Dialog"
                                :visible.sync="innerVisible"
                                append-to-body>
                        </el-dialog>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="outerVisible = false">取 消</el-button>
                            <el-button type="primary" @click="innerVisible = true">打开内层 Dialog</el-button>
                        </div>
                    </el-dialog>
                    |
                    <el-button type="text" @click="centerDialogVisible = true">点击打开 Dialog</el-button>
                    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
                        <span>需要注意的是内容是默认不居中的</span>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="centerDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
                        </span>
                    </el-dialog>
                    <hr>
                    <div class="box">
                        <div class="tooltip-top">
                            <el-tooltip class="tooltip-item" effect="dark" content="Top Left 提示文字"
                                        placement="top-start">
                                <el-button>上<br>左</el-button>
                            </el-tooltip>
                            <el-tooltip class="tooltip-item" effect="dark" content="Top Center 提示文字" placement="top">
                                <el-button>上<br>边</el-button>
                            </el-tooltip>
                            <el-tooltip class="tooltip-item" effect="dark" content="Top Right 提示文字" placement="top-end">
                                <el-button>上<br>右</el-button>
                            </el-tooltip>
                        </div>
                        <div class="tooltip-left">
                            <el-tooltip class="tooltip-item" effect="dark" content="Left Top 提示文字"
                                        placement="left-start">
                                <el-button>左<br>上</el-button>
                            </el-tooltip>
                            <el-tooltip class="tooltip-item" effect="dark" content="Left Center 提示文字" placement="left">
                                <el-button>左<br>边</el-button>
                            </el-tooltip>
                            <el-tooltip class="tooltip-item" effect="dark" content="Left Bottom 提示文字"
                                        placement="left-end">
                                <el-button>左<br>下</el-button>
                            </el-tooltip>
                        </div>

                        <div class="tooltip-right">
                            <el-tooltip class="tooltip-item" effect="dark" content="Right Top 提示文字"
                                        placement="right-start">
                                <el-button>右<br>上</el-button>
                            </el-tooltip>
                            <el-tooltip class="tooltip-item" effect="dark" content="Right Center 提示文字"
                                        placement="right">
                                <el-button>右<br>边</el-button>
                            </el-tooltip>
                            <el-tooltip class="tooltip-item" effect="dark" content="Right Bottom 提示文字"
                                        placement="right-end">
                                <el-button>右<br>下</el-button>
                            </el-tooltip>
                        </div>
                        <div class="tooltip-bottom">
                            <el-tooltip class="tooltip-item" effect="dark" content="Bottom Left 提示文字"
                                        placement="bottom-start">
                                <el-button>下<br>左</el-button>
                            </el-tooltip>
                            <el-tooltip class="tooltip-item" effect="dark" content="Bottom Center 提示文字"
                                        placement="bottom">
                                <el-button>下<br>边</el-button>
                            </el-tooltip>
                            <el-tooltip class="tooltip-item" effect="dark" content="Bottom Right 提示文字"
                                        placement="bottom-end">
                                <el-button>下<br>右</el-button>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="box1">
                        <el-tooltip content="Top center" placement="top">
                            <el-button>Dark</el-button>
                        </el-tooltip>
                        <el-tooltip content="Bottom center" placement="bottom" effect="light">
                            <el-button>Light</el-button>
                        </el-tooltip>
                        <el-tooltip placement="top">
                            <div slot="content">多行信息<br/>第二行信息</div>
                            <el-button>Top center</el-button>
                        </el-tooltip>
                        <el-tooltip :disabled="disabled" content="点击关闭 tooltip 功能" placement="bottom" effect="light">
                            <el-button @click="disabled = !disabled">点击{{disabled ? '开启' : '关闭'}} tooltip 功能</el-button>
                        </el-tooltip>
                    </div>
                    <hr>
                    <div class="box2">
                        <el-popover
                                placement="top-start"
                                title="标题"
                                width="200"
                                trigger="hover"
                                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <el-button slot="reference">hover 激活</el-button>
                        </el-popover>

                        <el-popover
                                placement="bottom"
                                title="标题"
                                width="200"
                                trigger="click"
                                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                            <el-button slot="reference">click 激活</el-button>
                        </el-popover>

                        <el-popover
                                ref="popover"
                                placement="right"
                                title="标题"
                                width="200"
                                trigger="focus"
                                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
                        </el-popover>
                        <el-button v-popover:popover>focus 激活</el-button>

                        <el-popover
                                placement="bottom"
                                title="标题"
                                width="200"
                                trigger="manual"
                                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                                v-model="visible">
                            <el-button slot="reference" @click="visible = !visible">手动激活</el-button>
                        </el-popover>
                        <el-popover
                                placement="right"
                                width="400"
                                trigger="click">
                            <el-table :data="gridData">
                                <el-table-column width="150" property="date" label="日期"></el-table-column>
                                <el-table-column width="100" property="name" label="姓名"></el-table-column>
                                <el-table-column width="300" property="address" label="地址"></el-table-column>
                            </el-table>
                            <el-button slot="reference">click 激活</el-button>
                        </el-popover>
                        <el-popover
                                placement="top"
                                width="160"
                                v-model="visible">
                            <p>这是一段内容这是一段内容确定删除吗？</p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                                <el-button type="primary" size="mini" @click="visible = false">确定</el-button>
                            </div>
                            <el-button slot="reference">删除</el-button>
                        </el-popover>
                    </div>
                    <div id="massage-box" style="display:none;">
                        <div class="massage-scroll-model b-r-4">
                            <el-scrollbar class="massage-scroll">
                                <div>
                                    <div style="height:auto;overflow:hidden;">
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <!-- <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode</i></p>
                                        <p class="asd"><span>内容可以是</span><i style="color: teal;">VNode1</i></p> -->
                                    </div>
                                </div>
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    import $ from 'jquery'

    export default {
        data() {
            return {
                centerDialogVisible: false,
                dialogVisible: false,
                outerVisible: false,
                innerVisible: false,
                gridData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }],
                dialogScrollVisible: false,
                dialogTableVisible: false,
                dialogFormVisible: false,
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
                formLabelWidth: '120px',
                disabled: false,
                visible: false,
            }
        },
        methods: {
            open() {
                this.$message('这是一条消息提示');
            },
            openVn() {
                const h = this.$createElement;
                this.$message({
                    message: h('p', null, [
                        h('span', null, '内容可以是 '),
                        h('i', {style: 'color: teal'}, 'VNode')
                    ])
                });
            },
            open2() {
                this.$message({
                    showClose: true,
                    message: '恭喜你，这是一条成功消息',
                    type: 'success',
                    center: true
                });
            },
            open3() {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    showClose: true,
                    message: '警告哦，这是一条警告消息<br><strong>这是 <i>HTML</i> 片段</strong>',
                    type: 'warning'
                });
            },
            open4() {
                this.$message({
                    showClose: true,
                    message: '错了哦，这是一条错误消息',
                    type: 'error'
                });
            },
            open5() {
                this.$alert('这是一段内容', '标题名称', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$message({
                            type: 'info',
                            message: `action: ${ action }`
                        });
                    }
                });
            },
            open6() {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            open7() {
                this.$prompt('请输入邮箱', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                    inputErrorMessage: '邮箱格式不正确'
                }).then(({value}) => {
                    this.$message({
                        type: 'success',
                        message: '你的邮箱是: ' + value
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            open8() {
                const h = this.$createElement;
                this.$msgbox({
                    title: '消息',

                    //内容编辑方法1
                    dangerouslyUseHTMLString: true,
                    message: $("#massage-box").html(),

                    //内容编辑方法2
                    // message: h("el-scrollbar", {class:'massage-scroll'},[]),
                    
                    /*message: h('div', {style:'max-height:660px;width:100%;overflow:auto'}, [
                        h('div', {style:'height:auto;overflow:hidden;width:100%'}, [
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                            h('p', {class: 'asdasd'}, [
                                h('span', null, '内容可以是 '),
                                h('i', { style: 'color: teal', class: 'aaa' }, 'VNode1'),
                            ]),
                        ])
                    ]),*/

                    showCancelButton: true,
                    customClass: 'newClass',//MessageBox 的自定义类名
                    lockScroll: true,//是否在 MessageBox 出现时将 body 滚动锁定 默认：true
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = '执行中...';
                            setTimeout(() => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            }, 3000);
                        } else {
                            done();
                            setTimeout(() => {
                                instance.confirmButtonLoading = false;
                            }, 300);
                        }
                    }
                }).then(action => {
                    this.$message({
                        type: 'info',
                        message: 'action: ' + action
                    });
                });
                this.$nextTick(() => {
                    // $(".massage-scroll").html($("#massage-box").html())
                })
            },
            open9() {
                this.$alert('<strong>这是 <i>HTML</i> 片段</strong>', 'HTML 片段', {
                    dangerouslyUseHTMLString: true
                });
            },
            open10() {
                this.$confirm('检测到未保存的内容，是否在离开页面前保存修改？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '保存',
                    cancelButtonText: '放弃修改',
                    center: true
                }).then(() => {
                    this.$message({
                        type: 'info',
                        message: '保存修改'
                    });
                })
                    .catch(action => {
                        this.$message({
                            type: 'info',
                            message: action === 'cancel'
                                ? '放弃保存并离开页面'
                                : '停留在当前页面'
                        })
                    });
            },
            open11() {
                const h = this.$createElement;
                this.$notify({
                    title: '标题名称',
                    message: h('i', {style: 'color: teal'}, '这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案'),
                    offset: 100
                });
            },

            open12() {
                this.$notify({
                    title: '提示',

                    message: '这是一条不会自动关闭的消息',
                    duration: 0
                });
            },
            open13() {
                this.$notify({
                    title: '成功',
                    dangerouslyUseHTMLString: true,
                    message: '这是一条成功的提示消息<br/><strong>这是 <i>HTML</i> 片段</strong>',
                    type: 'success'
                });
            },

            open14() {
                this.$notify({
                    title: '警告',
                    message: '这是一条警告的提示消息',
                    type: 'warning',
                    showClose: false,
                });
            },

            open15() {
                this.$notify.info({
                    title: '消息',
                    message: '这是一条消息的提示消息'
                });
            },

            open16() {
                this.$notify.error({
                    title: '错误',
                    message: '这是一条错误的提示消息'
                });
            },
            open17() {
                this.$notify({
                    title: '自定义位置',
                    message: '右上角弹出的消息'
                });
            },

            open18() {
                this.$notify({
                    title: '自定义位置',
                    message: '右下角弹出的消息',
                    position: 'bottom-right'
                });
            },

            open19() {
                this.$notify({
                    title: '自定义位置',
                    message: '左下角弹出的消息',
                    position: 'bottom-left'
                });
            },

            open20() {
                this.$notify({
                    title: '自定义位置',
                    message: '左上角弹出的消息',
                    position: 'top-left'
                });
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {
                    });
            }
        },
        mounted() {
            this.$parent.main_header_active = false;
            this.$nextTick(() => {
                $('#scrollbar-massage-model .el-dialog').css({height:($(window).height() - 280), width:1000});
            })
        },
        created() {
            this.$parent.routerLoading();
        },
    }
</script>
<style scoped lang="scss">
    .box {
        width: 400px;
    }

    .tooltip-left, .tooltip-right {
        width: 60px;
        & .el-tooltip__popper{
            padding: 8px 10px;
        }
    }
    
    $float:[left, right];   
    /* 
        scss @for 循环
     */
    @for $i from 1 through length($float) {
        $item: nth($float, $i);
        /* 获取每个的值 */
        .tooltip-#{$item} {
            float: #{$item}
        }
    }


    @mixin clearfix {
        clear: both;
    }
    @mixin box_shadow {
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        -moz-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    @mixin background($bg) {
        background: $bg;
    }
    @mixin p_set($p...) {
        padding: $p;
    }
    
    .tooltip-bottom {
        @include clearfix
    }
    .tooltip-bottom , .tooltip-top {
        text-align: center;
    }

    .tooltip-item {
        margin: 4px;
    }


    #scrollbar-massage-model {
        .scrollbar-model{
            @include box_shadow
        }
        .massage-scroll{
            @include p_set(10px 15px)
            @include background(#fff)
        }
    }
</style>
<style>
    #scrollbar-massage-model .el-dialog__body{
        padding: 10px 15px;
        height: calc(100% - 124px);
        background-color: #f1f1f1;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/message.vue